import { postApi } from "../components/Utility";
import { action, makeObservable, observable } from "mobx";
import config from "../config";

class BrushSweeperReportStore {
    country = [];
    dataArray = []
    total = 0;
    loading = false;
    rootStore;

    constructor(rootStore) {
        makeObservable(this, {
            country: observable,
            total: observable,
            loading: observable,
            dataArray: observable,
            loadData: action,

        });
        this.rootStore = rootStore;
    }

    async loadData({ companyId, offset, limit, vehicleId, fromDate, toDate, pageNo, }) {
        var postData = { "companyId": companyId, "vehicleId": vehicleId, "fromDate": fromDate, "toDate": toDate, "offset": offset, "limit": limit, "page": pageNo, }


        var response = await postApi.getClient("report").post("/alert_report/BrushReport", postData);


        this.dataArray = response?.data?.data?.BrushonoffData;

        return response?.data?.data?.BrushonoffData;
    }


}

export default BrushSweeperReportStore;
